import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepOneExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepOneExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.discoverStepOneExtraCollections.data.discoverStepOneExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.discoverStepOneExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
